(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"]) return;
  try {
    
  // Shopify accessibility checklist: focus is placed on the feedback message so
  // screen reader and keyboard users land on the outcome after the form posts.
  const feedback = document.querySelector('[data-form-feedback]');
  if (feedback) {
    feedback.focus({ preventScroll: false });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Adds the condensed scroll state and opens the mega menu on hover at
   * desktop widths. The disclosures themselves are native <details>, so
   * everything here is enhancement only.
   */
  class ZsHeader extends HTMLElement {
    connectedCallback() {
      this.mega = this.querySelector('[data-mega]');
      this.mobileMenu = this.querySelector('[data-mobile-menu]');
      this.closeTimer = null;
      this.desktop = window.matchMedia('(min-width: 990px)');

      if (this.dataset.sticky === 'true') {
        this.onScroll = this.onScroll.bind(this);
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      if (this.mega) {
        this.onEnter = this.onEnter.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);

        this.mega.addEventListener('mouseenter', this.onEnter);
        this.mega.addEventListener('mouseleave', this.onLeave);
        this.mega.querySelector('summary').addEventListener('click', this.onSummaryClick);
        this.onFocusIn = () => clearTimeout(this.closeTimer);
        this.onFocusOut = event => { if (!this.mega.contains(event.relatedTarget)) this.onLeave(); };
        this.onOutsideClick = event => { if (!this.mega.contains(event.target)) this.mega.open = false; };
        this.mega.addEventListener('focusin', this.onFocusIn);
        this.mega.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('click', this.onOutsideClick);
      }

      this.onToggle = () => {
        const open = Boolean(this.mobileMenu?.open);
        const toggle = this.mobileMenu?.querySelector('summary');
        if (toggle) toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
        document.querySelectorAll('#MainContent, .shopify-section-group-footer-group').forEach(node => { node.inert = open; });
        this.querySelectorAll('.header__logo, .header__nav, .header__actions > :not(.header__drawer)').forEach(node => { node.inert = open; });
        if (open) this.mobileMenu.querySelector('.mobile-nav__body').scrollTop = 0;
      };
      this.mobileMenu?.addEventListener('toggle', this.onToggle);
      this.onKeydown = this.onKeydown.bind(this);
      this.addEventListener('keydown', this.onKeydown);

      // Close the mobile drawer on resize up to desktop so the scroll lock
      // cannot outlive the layout it belongs to.
      this.onResize = this.onResize.bind(this);
      this.desktop.addEventListener('change', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.desktop.removeEventListener('change', this.onResize);
      clearTimeout(this.closeTimer);
      this.mobileMenu?.removeEventListener('toggle', this.onToggle);
      this.mega?.removeEventListener('mouseenter', this.onEnter);
      this.mega?.removeEventListener('mouseleave', this.onLeave);
      this.mega?.querySelector('summary').removeEventListener('click', this.onSummaryClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.mega?.removeEventListener('focusin', this.onFocusIn);
      this.mega?.removeEventListener('focusout', this.onFocusOut);
      document.removeEventListener('click', this.onOutsideClick);
      document.querySelectorAll('#MainContent, .shopify-section-group-footer-group').forEach(node => { node.inert = false; });
      this.querySelectorAll('.header__logo, .header__nav, .header__actions > :not(.header__drawer)').forEach(node => { node.inert = false; });
    }

    onScroll() {
      this.classList.toggle('header--condensed', window.scrollY > 50);
    }

    onEnter() {
      if (!this.desktop.matches) return;
      clearTimeout(this.closeTimer);
      this.mega.open = true;
    }

    onLeave() {
      if (!this.desktop.matches) return;
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (!this.mega.matches(':hover') && !this.mega.contains(document.activeElement)) this.mega.open = false;
      }, 400);
    }

    onSummaryClick(event) {
      clearTimeout(this.closeTimer);
      // Hover has already opened the disclosure before a mouse click arrives.
      if (event.detail > 0 && this.mega.open && window.matchMedia('(hover: hover)').matches) event.preventDefault();
    }

    onKeydown(event) {
      if (event.key === 'Tab' && this.mobileMenu?.open) {
        const controls = Array.from(this.mobileMenu.querySelectorAll('summary, a[href], button, input, select, textarea, [tabindex]'))
          .filter(control => control.tabIndex >= 0 && !control.disabled && control.getClientRects().length > 0
            && !control.closest('details:not([open]) > :not(summary)'));
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
      if (event.key !== 'Escape') return;
      if (this.mega && this.mega.open) {
        this.mega.open = false;
        this.mega.querySelector('summary').focus();
      }
      if (this.mobileMenu && this.mobileMenu.open) {
        this.mobileMenu.open = false;
        this.mobileMenu.querySelector('summary').focus();
      }
    }

    onResize() {
      if (this.desktop.matches && this.mobileMenu) {
        this.mobileMenu.open = false;
      }
    }
  }

  if (!customElements.get('zs-header')) {
    customElements.define('zs-header', ZsHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Minimal slide carousel: toggles `is-active` on slides and dots. Replaces
   * the Framer Motion `AnimatePresence` version with a CSS cross-fade.
   */
  class ZsCarousel extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;

      if (this.slides.length < 2) return;

      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');

      if (prev) prev.addEventListener('click', () => this.go(this.index - 1), options);
      if (next) next.addEventListener('click', () => this.go(this.index + 1), options);

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i), options);
      });

      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.closest('.shopify-section')?.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.go(index);
      }, options);
    }

    disconnectedCallback() { this.controller?.abort(); }

    go(target) {
      const count = this.slides.length;
      const next = ((target % count) + count) % count;

      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.slides[this.index].setAttribute('tabindex', '-1');

      this.slides[next].classList.add('is-active');
      this.slides[next].removeAttribute('aria-hidden');
      this.slides[next].removeAttribute('tabindex');

      if (this.dots.length) {
        this.dots[this.index].classList.remove('is-active');
        this.dots[this.index].setAttribute('aria-pressed', 'false');
        this.dots[next].classList.add('is-active');
        this.dots[next].setAttribute('aria-pressed', 'true');
      }

      const selection = this.querySelector('[data-selection]');
      if (selection) {
        selection.textContent = this.slides[next].dataset.title;
        selection.href = this.slides[next].href;
      }
      this.index = next;
    }
  }

  if (!customElements.get('zs-carousel')) {
    customElements.define('zs-carousel', ZsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ZsRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.recommendations')) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.request?.abort(); }
    async load() {
      this.request = new AbortController();
      try {
        const response = await fetch(this.dataset.url, { signal: this.request.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('.recommendations');
        if (content) this.replaceChildren(content);
      } catch { /* Recommendations are optional; the product form stays available. */ }
    }
  }
  if (!customElements.get('zs-recommendations')) customElements.define('zs-recommendations', ZsRecommendations);

  } catch(e) { console.error(e); }
})();
})();
